// extracted by mini-css-extract-plugin
export default {"container":"Hk-z","bubbleNav":"Ik-z","graphic":"Jk-z","contact":"Kk-z"};